<template>
  <div class="login-background" >
    <div class="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <!-- <img class="mx-auto h-10 w-auto" src="https://firebasestorage.googleapis.com/v0/b/mesh-db-stg.appspot.com/o/icons%2Fmeshcomm-icon.png?alt=media&token=44dedc55-ef54-4256-a204-de8cd84829db" alt="Meshportal icon" /> -->
        <h2 class="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-white">Reset Password</h2>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
        <div class="bg-mc-white px-6 py-12 shadow-mc-sm sm:rounded-mc-md sm:px-12">
          <p class="text-sm text-ink-muted mb-5">Enter the email associated with your account.</p>
          <form class="space-y-6" @submit.prevent="resetPassword">
            <div>
              <label for="email" class="block text-xs font-semibold text-mc-ink mb-1">Email address</label>
              <div class="mt-1">
                <input id="email" name="email" type="email" autocomplete="email" v-model="email" required="" class="block w-full rounded-mc-sm border border-mc-steel bg-mc-white py-1.5 px-3 text-sm text-mc-ink focus:outline-none focus:ring-2 focus:ring-mc-blue/40" />
              </div>
            </div>

            <p id="message" :ref="message" v-if="message" class="font-semibold text-mc-blue text-sm">{{ message }}</p>

            <div class="space-y-3">
              <button id="sendEmail" type="submit" :disabled="isLoading" class="w-full inline-flex justify-center items-center rounded-pill border-2 border-mc-red bg-mc-red px-4 py-2 text-sm font-bold text-white transition-colors duration-160 hover:bg-mc-red-700 hover:border-mc-red-700 disabled:opacity-60">{{ isLoading ? 'Sending email...' : 'Reset password' }}</button>
              <button id="returnLogin" type="button" @click="login" class="w-full inline-flex justify-center items-center rounded-pill border-2 border-mc-ink bg-transparent px-4 py-2 text-sm font-bold text-mc-ink transition-colors duration-160 hover:bg-mc-ink hover:text-white">Back to login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '@/firebase';

export default {
  name: 'ResetPassword',
  setup() {
    const email = ref('');
    const message = ref(null);
    const isLoading = ref(false);
    const router = useRouter();

    const resetPassword = async () => {
      isLoading.value = true;
      await sendPasswordResetEmail(auth, email.value)
      .then(() => {
        message.value = "An email was sent";
      })
      .catch ((error) => {
        message.value = error.code;
      });
      isLoading.value = false;
    };

    const login = () => {
      router.push({ name: 'Login' });
    };

    return {
      email,
      message,
      isLoading,
      resetPassword,
      login
    };
  },
};
</script>

<style>
.login-background {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 98vh;
  background-image: url('@/assets/images/MeshComm-Hero-Area-SIGNAL.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
